import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getChannelList } from "@/api/channel";
export var gameChannel = {
  namespaced: true,
  state: {
    isInit: 0,
    channelKv: {}
  },
  mutations: {
    setChannelKv: function setChannelKv(state, channelMap) {
      state.isInit = 1;
      state.channelKv = channelMap;
    }
  },
  actions: {
    getChannel: function getChannel(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, channelMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return getChannelList();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                channelMap = {};
                res.data.forEach(function (val) {
                  channelMap[val.channel_id] = val.channel_name;
                });
                commit("setChannelKv", channelMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    channelMap: function channelMap(state) {
      return state.channelKv;
    }
  }
};